enum FORMS_ACTION_TYPES {
  'get_doctors_begins' = 'get_doctors_begins',
  'get_doctors_success' = 'get_doctors_success',
  'get_doctors_error' = 'get_doctors_error',
  'update_doctor' = 'update_doctor'
}
export default FORMS_ACTION_TYPES



// WEBPACK FOOTER //
// ./src/store/careProfessionals/types.ts